'use client';

import clsx from 'clsx';
import { FC, useEffect, useState } from 'react';
import Divider from '~/components/divider';
import CommonData from '~/data/strapi/types/single-types/common-data';

import CityMobileBar from '../../city/mobile-bar';
import CityMobileSelect from '../../city/mobile-select';
import BurgerContacts from './contacts';
import BurgerNavigation from './navigation';
import styles from './styles.module.css';

interface Props {
  show: boolean;
  commonData: CommonData;
  onCallClick: () => void;
}

const Menu: FC<Props> = ({ show, commonData, onCallClick }) => {
  const links = commonData.menu?.links || null;
  const [showCitySelect, setShowCitySelect] = useState(false);

  useEffect(() => {
    if (!show) setShowCitySelect(false);
  }, [show]);

  return (
    <div className={styles.container}>
      <div className={clsx(styles.menu, show && styles.active)}>
        <CityMobileBar active={showCitySelect} onToggle={() => setShowCitySelect((prev) => !prev)} />

        {showCitySelect ? (
          <CityMobileSelect onSelect={() => setShowCitySelect(false)} />
        ) : (
          links && <BurgerNavigation links={links} />
        )}

        <Divider className={styles.divider} />
        <BurgerContacts commonData={commonData} onCallClick={onCallClick} />
      </div>
    </div>
  );
};

export default Menu;
